import type { ToolHandler, PointerSample } from "../canvas/PointerInput";
import type { EditorContext } from "./EditorContext";

export interface Tool extends ToolHandler {
  id: string;
  label: string;
  cursor?: string;
  /** Single-key keyboard shortcut, lowercase (e.g. "r" for Shape). Surfaced
   *  in the toolbar's hover tooltip on devices with a keyboard. Tools without
   *  a shortcut leave it undefined. */
  shortcut?: string;
  onActivate?: () => void;
  onDeactivate?: () => void;
  /** Optional UI fragment for the properties panel. */
  renderOptions?: (root: HTMLElement) => void;
}

export abstract class ToolBase implements Tool {
  abstract id: string;
  abstract label: string;
  cursor?: string;
  shortcut?: string;
  protected ctx: EditorContext;

  constructor(ctx: EditorContext) {
    this.ctx = ctx;
  }

  onActivate?(): void;
  onDeactivate?(): void;
  onDown?(s: PointerSample, p: { x: number; y: number }): void;
  onMove?(s: PointerSample, p: { x: number; y: number }): void;
  onUp?(s: PointerSample, p: { x: number; y: number }): void;
  onHover?(s: PointerSample, p: { x: number; y: number }): void;
  onCancel?(): void;
  /** See `ToolHandler.gestureSurvivesSecondContact` — true while the gesture
   *  in flight is deliberate placement that a resting hand must not abandon. */
  gestureSurvivesSecondContact?(): boolean;
  onModifiersChanged?(modifiers: {
    shiftKey: boolean;
    ctrlKey: boolean;
    metaKey: boolean;
    altKey: boolean;
  }): void;
  renderOptions?(root: HTMLElement): void;
}
